import type { TransactionEnvelope } from "@saberhq/solana-contrib";
import type { PublicKey } from "@solana/web3.js";

export interface PendingInitActivity {
  tx: TransactionEnvelope;
  activityMaster: PublicKey;
  authority: PublicKey;
}

export interface PendingMint {
  tx: TransactionEnvelope;
  mint: PublicKey;
  user: PublicKey;
  receiverTokenAccount: PublicKey;
  metadata: PublicKey;
  activityMetadata: PublicKey;
}
